import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { HeaderComponent } from './pages/header/header.component';
import { HomeComponent } from './pages/home/home.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './pages/login/login.component';
import { CatDetailsComponent } from './pages/cat-details/cat-details.component';
import { ProdDetailsComponent } from './pages/prod-details/prod-details.component';
import { ClientRegisterComponent } from './pages/client-register/client-register.component';
import { AllClientsComponent } from './pages/all-clients/all-clients.component';
import { ClientDetailsComponent } from './pages/client-details/client-details.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { OrdersDetailsComponent } from './pages/orders-details/orders-details.component';
import { SideBarComponent } from './pages/side-bar/side-bar.component';
import { ToastrModule } from 'ngx-toastr';
import { MainComponent } from './pages/main/main.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PackegsComponent } from './pages/packegs/packegs.component';
import { PackegDetailsComponent } from './pages/packeg-details/packeg-details.component';
import { OrderRequestComponent } from './pages/order-request/order-request.component';
import { PromocodeComponent } from './pages/promocode/promocode.component';
import { BlogsComponent } from './pages/blogs/blogs.component';
import { BlogDetailsComponent } from './pages/blog-details/blog-details.component';
import { PromoDetailsComponent } from './pages/promo-details/promo-details.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CancelledOrdersComponent } from './pages/cancelled-orders/cancelled-orders.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ArchivedOrdersComponent } from './pages/archived-orders/archived-orders.component';
import { AdminRegisterComponent } from './pages/admin-register/admin-register.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { AllUsersComponent } from './pages/all-users/all-users.component';
import { UserDetailsComponent } from './pages/user-details/user-details.component';
import { DeliveryComponent } from './pages/delivery/delivery.component';
import { TranslatePipe } from './pipes/translate.pipe';
import { CustomToastComponent } from './components/custom-toast/custom-toast.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    CategoriesComponent,
    LoginComponent,
    CatDetailsComponent,
    ProdDetailsComponent,
    ClientRegisterComponent,
    AllClientsComponent,
    ClientDetailsComponent,
    OrdersComponent,
    CancelledOrdersComponent,
    ArchivedOrdersComponent,
    OrdersDetailsComponent,
    SideBarComponent,
    MainComponent,
    PackegsComponent,
    PackegDetailsComponent,
    OrderRequestComponent,
    PromocodeComponent,
    BlogsComponent,
    BlogDetailsComponent,
    PromoDetailsComponent,
    AdminRegisterComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AllUsersComponent,
    UserDetailsComponent,
    DeliveryComponent,
    TranslatePipe,
    CustomToastComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule.forRoot({ type: 'square-jelly-box' }),
    ToastrModule.forRoot({
      toastComponent: CustomToastComponent,
      positionClass: 'toast-top-right',
      timeOut: 4000,
      progressBar: true,
      maxOpened: 5,
      autoDismiss: true,
      tapToDismiss: true,
      newestOnTop: true,
      preventDuplicates: true,
    }),
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
